module.exports = __webpack_public_path__ + "static/media/sabayon.4d3dd735.JPG";